export const adaptPersonDetail = (data: IPersonProfile): PersonDetail => {
	return {
		socialProfile: data.social_profile
			? {
					id: data.social_profile.id,
					jobTitle: data.social_profile.job_title,
					orgTeamLevelOne: data.social_profile.org_team_level_one,
					orgTeamLevelTwo: data.social_profile.org_team_level_two,
					orgTeamLevelThree: data.social_profile.org_team_level_three,
					photoFrame: data.social_profile.photo_frame,
					preferredFeed: data.social_profile.preferred_feed,
					subscribedFeeds: data.social_profile.subscribed_feeds,
					socialProfileGroups: data.social_profile.social_profile_groups
				}
			: null,
		authUser: data.auth_user
			? {
					id: data.auth_user.id,
					username: data.auth_user.username,
					isActive: data.auth_user.is_active,
					isStaff: data.auth_user.is_staff,
					isSuperuser: data.auth_user.is_superuser,
					groups: data.auth_user.groups,
					lastLogin: data.auth_user.last_login,
					dateJoined: data.auth_user.date_joined
				}
			: null
	};
};
